import React from 'react';

import { UiButton } from '../../../../ui/ui-button';
import { UiDialog } from '../../../../ui/ui-dialog';

type InputProps = {
  close: () => void;
};

export const ReactivateUsersDialog = (props: InputProps) => (
  <UiDialog onClose={props.close} title="Activate users">
    <UiDialog.Content>
      Please confirm with the customer which users should be created or reactivated. This is not
      done automatically.
    </UiDialog.Content>
    <UiDialog.Actions>
      <UiButton variant="primary" onClick={props.close}>
        OK
      </UiButton>
    </UiDialog.Actions>
  </UiDialog>
);
